// extracted by mini-css-extract-plugin
module.exports = {"ModalBodyContent":"ModalystOrderPaymentCompleteModal_ModalBodyContent__1ZD9-"};